import React from 'react';
import Modal from '@material-ui/core/Modal';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useGeneral } from '../../Context/GeneralContext';
import { useHome } from '../../pages/Home/HomeContext';
import '../../styles/modalConfirm.css';
import { Button } from '@material-ui/core';
import { LetterX } from 'tabler-icons-react';

// Catálogo desde GET /TiposLlamada/ListadoParosAutorizados: [{ codigo, nombre, ... }]
const getCodigo = (item) => item.codigo;
const getNombre = (item) => item.nombre;

export default function ModalIniEsp() {
    const { setOpenIniEsp, openIniEsp, setConfirmIniEsp } = useGeneral();
    const { parosEsp, selectParoEsp, setSelectParoEsp } = useHome();

    const handleClose = () => {
        setOpenIniEsp(false);
    };

    const handleChangeParo = (e) => {
        setSelectParoEsp(e.target.value);
    };

    const sinSeleccion =
        selectParoEsp === '' || selectParoEsp === undefined || selectParoEsp === null;

    const handleConfirmar = () => {
        // Requerimos elegir un tipo de paro antes de registrar (criterio de aceptación NOVA-20).
        if (sinSeleccion) return;
        handleClose();
        setConfirmIniEsp(true);
    };

    const body = (
        <div className="modalConf-paper modalConf-paper--iniEsp">
            <div className="modalConf-head modalConf-head--iniEsp">
                <div className="modalConf-text">
                    <h4 className="modalConf-text-field">Iniciar Paro Autorizado</h4>
                </div>
                <div className="modalConf-exit">
                    <LetterX
                        size={22}
                        color={'#ffffff'}
                        onClick={handleClose}
                        className="modalConf-exit-icon"
                    />
                </div>
            </div>
            <div className="modalConf-body">
                <div className="modalConf-body-text">
                    <h1>Seleccione el tipo de paro autorizado</h1>
                </div>
                <div className="modalConf-select">
                    <FormControl variant="outlined" className="modalConf-select-control">
                        <Select
                            id="tipo-paro-autorizado"
                            value={selectParoEsp ?? ''}
                            onChange={handleChangeParo}
                            displayEmpty
                            className="modalConf-select-input"
                            MenuProps={{
                                classes: { paper: 'modalConf-select-menu' },
                                getContentAnchorEl: null,
                                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                            }}
                        >
                            <MenuItem value="" disabled>
                                Seleccione un tipo de paro
                            </MenuItem>
                            {(parosEsp || []).map((item, index) => (
                                <MenuItem value={getCodigo(item)} key={getCodigo(item) ?? index}>
                                    {getNombre(item)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div className="modalConf-body-buttons">
                    <div className="modalConf-body-buttons-first">
                        <Button
                            className="modalM-body-buttonS modalM-body-buttonS--iniEsp"
                            disabled={sinSeleccion}
                            onClick={handleConfirmar}
                        >
                            <h1>Confirmar</h1>
                        </Button>
                    </div>

                    <div className="modalConf-body-buttons-second">
                        <Button
                            className="modalM-body-buttonC modalM-body-buttonC--iniEsp"
                            onClick={handleClose}
                        >
                            <h1>Cancelar</h1>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <Modal
                open={openIniEsp}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
